export default __webpack_public_path__ + "static/media/revit-robot-poster.061face2.jpeg";